<template>
    <div :class="theme.navigation">
        <div :class="theme.logo">
            <v-router-link :to="{ name: 'login' }">
                <v-logo white />
            </v-router-link>
        </div>
        <div :class="theme.create">
            <v-router-link :to="{ name: 'requestProducts' }">
                <v-button primary>
                    Создать запрос
                </v-button>
            </v-router-link>
        </div>
        <div :class="theme.links">
            <v-spinner v-if="products.length == 0" transparent green block />
            <div v-else>
                <v-router-link :exact-active-class="route.path === '/' ? theme.isActiveLink : undefined"
                    :active-class="route.path !== '/' ? theme.isActiveLink : undefined" :to="route.path"
                    v-for="route, index in routes" :key="index" :class="theme.link">
                    <v-font-icon inherit>{{ route.meta.icon }}</v-font-icon>
                    <span v-margin.left="2">{{ route.meta.title }}</span>
                </v-router-link>
                <v-link :active-class="theme.isActiveLink" :class="theme.link" :to="'https://t.me/lkexbico_bot'">
                    <v-font-icon inherit>send</v-font-icon>
                    <span v-margin.left="2">Телеграм бот</span>
                </v-link>
            </div>

            <v-link v-if="refinanceIntegrated" :class="theme.link" to="/refinance/analysis">
                <v-font-icon inherit>assessment</v-font-icon>
                <span v-margin.left="2">Анализ КИ</span>
            </v-link>
        </div>
    </div>
</template>
<script>
import theme from './theme.scss';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'navigation',
    props: {
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    computed: {
        routes() {
            const routes = this.$router.options.routes
            const monitoring = routes.find(route => route.name === 'monitoring')
            const isMonitoringActive = this.products.some(product => product.name === 'Мониторинг')
            if (isMonitoringActive) {
                monitoring.meta.navigation = true
            }
            return routes.filter((route) => route.meta && route.meta.navigation);
        },
        ...mapState('request', ['products']),
        ...mapGetters('profile', ['refinanceIntegrated', 'profile'])
    }
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?4b356e96